export enum BankAccountState {
  VERIFIED = 'VERIFIED',
  INVALID = 'INVALID',
  VERIFYING = 'VERIFYING',
}
